import React from 'react';
import PropTypes from 'prop-types';

const Buttons = props => (
  <section className="module-filter top align-right-simple-button">
    <div>
      <div className="box-form">
        {props.buttonShow && (
          <ul className="buttom_menu">
            <li>
              <a 
                className="buttom_menu"
                onClick={props.handleModal}
                data-close="ok"
                data-record="new">
                {props.language.account.workingShiftGroup.createModalTitle}
              </a>
            </li>
          </ul>
        )}
      </div>
    </div>
  </section>
);

export default Buttons;



// WEBPACK FOOTER //
// ./source/client/components/account_working_shift_group/buttons.jsx